// src/belediye/components/utils/BottomSheet.js
//
// PAYLAŞILAN alttan-çekmece (bottom-sheet) — tek kaynak, her yerde AYNI.
// InfoPopover'ın mobil çekmecesiyle BİREBİR aynı mantık/görünüm:
//   • React Portal ile document.body'ye render → sticky/sidebar altında kalmaz
//   • karartma (backdrop) + tutamak (grabber) + başlık + kapat
//
// Kullanım:
//   <BottomSheet open={isOpen} onClose={close} title="Birimler">
//     {/* içerik */}
//   </BottomSheet>

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

import "./BottomSheet.css";

export default function BottomSheet({ open, onClose, title, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape" && typeof onClose === "function") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="ui-sheet-overlay">
      <div
        className="ui-sheet-backdrop"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="ui-sheet" role="dialog" aria-label={title || "Panel"}>
        <div className="ui-sheet-grabber" aria-hidden="true" />
        {title ? (
          <div className="ui-sheet-head">
            <span className="ui-sheet-title">{title}</span>
            <button
              type="button"
              className="ui-sheet-close"
              onClick={onClose}
              aria-label="Kapat"
            >
              <XMarkIcon />
            </button>
          </div>
        ) : null}
        <div className="ui-sheet-body">{children}</div>
      </div>
    </div>,
    document.body
  );
}
